// import React, { useState, useEffect } from "react";
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Button,
//   Typography,
//   Box,
//   Checkbox,
//   FormControlLabel,
//   Divider,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   CircularProgress,
// } from "@mui/material";
// import { fetchSurveyWeeks } from "../../api/overviewApi";


// function formatWeek(isoDate) {
//   if (!isoDate) return "";
//   const d = new Date(`${isoDate}T00:00:00`);
//   return d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
// }

// export default function OnboardingAgreement({
//   open,
//   onAccept,
//   onBack,
//   saving,
//   initialPreferences = true,
//   onPreferenceChange,
//   initialStartWeek = "",
//   initialEndWeek = "",
//   onScheduleChange,
// }) {
//   const [checked, setChecked] = useState(initialPreferences);

//   // -- Survey Schedule State --
//   const [scheduleOpen, setScheduleOpen] = useState(false);
//   const [startOptions, setStartOptions] = useState([]);
//   const [endOptions, setEndOptions] = useState([]);
//   const [startWeek, setStartWeek] = useState(initialStartWeek);
//   const [endWeek, setEndWeek] = useState(initialEndWeek);
//   const [draftStartWeek, setDraftStartWeek] = useState("");
//   const [draftEndWeek, setDraftEndWeek] = useState("");
//   const [loadingWeeks, setLoadingWeeks] = useState(false);

//   const handleChange = (e) => {
//     setChecked(e.target.checked);
//     onPreferenceChange?.(e.target.checked);
//   };

//   const openScheduleModal = () => {
//     setDraftStartWeek(startWeek);
//     setDraftEndWeek(endWeek);
//     setScheduleOpen(true);
//   };

//   useEffect(() => {
//     if (!scheduleOpen) return;
//     setLoadingWeeks(true);
//     fetchSurveyWeeks()
//       .then((data) => setStartOptions(data.startOptions))
//       .catch((err) => console.error("Error fetching survey weeks:", err))
//       .finally(() => setLoadingWeeks(false));
//   }, [scheduleOpen]);

//   useEffect(() => {
//     if (!draftStartWeek) {
//       setEndOptions([]);
//       return;
//     }
//     fetchSurveyWeeks(draftStartWeek)
//       .then((data) => setEndOptions(data.endOptions || []))
//       .catch((err) => console.error("Error fetching end weeks:", err));
//   }, [draftStartWeek]);

//   const handleDraftStartChange = (e) => {
//     setDraftStartWeek(e.target.value);
//     setDraftEndWeek(""); // Reset end week when start week changes
//   }

//   const handleScheduleConfirm = () => {
//     setStartWeek(draftStartWeek);
//     setEndWeek(draftEndWeek);
//     onScheduleChange?.(draftStartWeek, draftEndWeek);
//     setScheduleOpen(false);
//   };

//   const scheduleChosen = Boolean(startWeek && endWeek);

//   return (
//     <>
//       <Dialog open={open} maxWidth="md" fullWidth disableEscapeKeyDown>
//         <DialogTitle>
//           <Box sx={{ textAlign: "center", pt: 2 }}>
//             <Typography variant="h4" gutterBottom>
//               Data Use & Privacy
//             </Typography>
//             <Typography
//               variant="subtitle1"
//               color="text.secondary"
//               sx={{ fontStyle: "italic" }}
//             >
//               Review and confirm your preferences
//             </Typography>
//           </Box>
//         </DialogTitle>

        
//         <DialogContent dividers>
//           {/* Notification Settings */}
//           <Box sx={{ mb: 4 }}>
//             <Typography variant="h6" gutterBottom>
//               Notification Settings
//             </Typography>

//             <FormControlLabel
//               control={
//                 <Checkbox
//                   checked={checked}
//                   onChange={handleChange}
//                   color="primary"
//                 />
//               }
//               label="Send me a weekly reminder to check the dashboard"
//             />

//             <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
//               Notifications will be sent to your institutional email address.
//             </Typography>
//           </Box>

//           <Divider sx={{ my: 3 }} />

//           {/* Survey Schedule */}
//             <Box sx={{ mb: 4 }}>
//               <Typography variant="h6" gutterBottom>
//                 Survey Schedule
//               </Typography>
  
//               <Button variant="outlined" onClick={openScheduleModal}>
//                 {scheduleChosen ? "Change Survey Schedule" : "Select Survey Weeks"}
//               </Button>
  
//               {scheduleChosen && (
//                 <Typography variant="body2" sx={{ mt: 1.5 }}>
//                   Surveys will run <strong>{formatWeek(startWeek)}</strong> through{" "}
//                   <strong>{formatWeek(endWeek)}</strong>.
//                 </Typography>
//               )}
//             </Box>

//           {/* Data Use & Privacy */}
//           <Box>
//             <Typography variant="h6" gutterBottom>
//               By accepting this agreement, you acknowledge that:
//             </Typography>

//             <Box
//               component="ul"
//               sx={{
//                 pl: 3,
//                 "& li": { mb: 1 },
//               }}
//             >
//               <li>
//                 Downstream will collect student survey responses and Canvas
//                 activity data (e.g., participation, engagement patterns).
//               </li>
//               <li>
//                 Downstream reflection surveys are automatically created as <strong>0-point</strong> Canvas quizzes by default, 
//                 but you can integrate them into your course in the way that works best for you.
//               </li>
//               <li>
//                 Data will be used to generate course-level and student-level
//                 insights and support early identification of students who may need
//                 assistance.
//               </li>
//               <li>
//                 Data may also be used to improve the functionality and
//                 effectiveness of the system.
//               </li>
//               <li>
//                 All data are handled in accordance with institutional policies and
//                 applicable regulations (e.g., FERPA).
//               </li>
//               <li>
//                 Access to data is <strong>role-based and restricted</strong> to authorized users
//                 (e.g., instructors, approved personnel).
//               </li>
//             </Box>
//           </Box>
//         </DialogContent>

//         <DialogActions sx={{ p: 3, justifyContent: "space-between" }}>
//           <Button onClick={onBack} color="inherit">
//             Back
//           </Button>

//           <Button
//             variant="contained"
//             onClick={onAccept}
//             disabled={saving}
//             sx={{
//               minWidth: 200,
//               background: "linear-gradient(135deg, #2FA4C7, #5DBB3A)",
//               color: "#fff",
//               "&:hover": {
//                 background: "linear-gradient(135deg, #1F8FA3, #4FA52F)",
//               },
//             }}
//           >
//             {saving ? "Saving..." : "Agree & Continue"}
//           </Button>
//         </DialogActions>
//       </Dialog>

//       { /* Survey Schedule Modal */ }
//       <Dialog open={scheduleOpen} onClose={() => setScheduleOpen(false)} maxWidth="sm" fullWidth>
//         <DialogTitle>Choose Your Survey Schedule</DialogTitle>
//         <DialogContent dividers>
//           <Typography variant="body2" sx={{ mb: 2 }}>
//             Select the start and end weeks for your reflection surveys. Surveys will be
//             created and spaced evenly within that window.
//           </Typography>
 
//           {loadingWeeks ? (
//             <Box display="flex" justifyContent="center" alignItems="center" minHeight="120px">
//               <CircularProgress />
//             </Box>
//           ) : (
//             <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
//               <FormControl sx={{ minWidth: 200 }} size="small">
//                 <InputLabel id="start-week-label">Start Week</InputLabel>
//                 <Select
//                   labelId="start-week-label"
//                   label="Start Week"
//                   value={draftStartWeek}
//                   onChange={handleDraftStartChange}
//                 >
//                   {startOptions.map((w) => (
//                     <MenuItem key={w} value={w}>{formatWeek(w)}</MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
 
//               <FormControl sx={{ minWidth: 200 }} size="small">
//                 <InputLabel id="end-week-label">End Week</InputLabel>
//                 <Select
//                   labelId="end-week-label"
//                   label="End Week"
//                   value={draftEndWeek}
//                   onChange={(e) => setDraftEndWeek(e.target.value)}
//                   disabled={!draftStartWeek}
//                 >
//                   {endOptions.map((w) => (
//                     <MenuItem key={w} value={w}>{formatWeek(w)}</MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Box>
//           )}
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setScheduleOpen(false)}>Cancel</Button>
//           <Button
//             onClick={handleScheduleConfirm}
//             disabled={!draftStartWeek || !draftEndWeek}
//             variant="contained"
//           >
//             Confirm
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </>
//   );
// }


import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Checkbox,
  FormControlLabel,
  Divider,
  CircularProgress,
} from "@mui/material";
import { fetchSurveyWeeks } from "../../api/overviewApi";
import SurveyScheduleCalendar from "../../components/SurveyScheduleCalendar";

// Mirrors services/surveySchedule.js WEEK_STARTS — used only to render the calendar grid.
// Actual selectability always comes from the backend's /survey-weeks response, not this list.
const ALL_WEEK_STARTS = [
  "2026-08-24", "2026-08-31", "2026-09-08", "2026-09-14",
  "2026-09-21", "2026-09-28", "2026-10-05", "2026-10-12",
  "2026-10-19", "2026-10-26", "2026-11-02", "2026-11-09",
  "2026-11-16", "2026-11-23", "2026-11-30", "2026-12-07"
];

function formatWeek(isoDate) {
  if (!isoDate) return "";
  const d = new Date(`${isoDate}T00:00:00`);
  return d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
}

export default function OnboardingAgreement({
  open,
  onAccept,
  onBack,
  saving,
  initialPreferences = true,
  onPreferenceChange,
  initialStartWeek = "",
  initialEndWeek = "",
  onScheduleChange,
}) {
  const [checked, setChecked] = useState(initialPreferences);

  // ─── Survey schedule state ───────────────────────────────────────────────
  const [scheduleOpen, setScheduleOpen] = useState(false);
  const [startOptions, setStartOptions] = useState([]);
  const [endOptions, setEndOptions] = useState([]);
  const [startWeek, setStartWeek] = useState(initialStartWeek);
  const [endWeek, setEndWeek] = useState(initialEndWeek);
  const [draftStartWeek, setDraftStartWeek] = useState("");
  const [draftEndWeek, setDraftEndWeek] = useState("");
  const [stage, setStage] = useState("start"); // "start" | "end"
  const [loadingWeeks, setLoadingWeeks] = useState(false);

  const handleChange = (e) => {
    setChecked(e.target.checked);
    onPreferenceChange?.(e.target.checked);
  };

  const openScheduleModal = () => {
    setDraftStartWeek(startWeek);
    setDraftEndWeek(endWeek);
    setStage(startWeek ? "end" : "start");
    setScheduleOpen(true);
  };

  useEffect(() => {
    if (!scheduleOpen) return;
    setLoadingWeeks(true);
    fetchSurveyWeeks()
      .then((data) => setStartOptions(data.startOptions || []))
      .catch((err) => console.error("Error fetching survey start weeks:", err))
      .finally(() => setLoadingWeeks(false));
  }, [scheduleOpen]);

  useEffect(() => {
    if (!draftStartWeek) {
      setEndOptions([]);
      return;
    }
    fetchSurveyWeeks(draftStartWeek)
      .then((data) => setEndOptions(data.endOptions || []))
      .catch((err) => console.error("Error fetching survey end weeks:", err));
  }, [draftStartWeek]);

  const handleCalendarClick = (iso) => {
    if (stage === "start") {
      setDraftStartWeek(iso);
      setDraftEndWeek("");
      setStage("end");
    } else {
      setDraftEndWeek(iso);
    }
  };

  const handleRestartSelection = () => {
    setDraftStartWeek("");
    setDraftEndWeek("");
    setStage("start");
  };

  const handleScheduleConfirm = () => {
    setStartWeek(draftStartWeek);
    setEndWeek(draftEndWeek);
    onScheduleChange?.(draftStartWeek, draftEndWeek);
    setScheduleOpen(false);
  };

  const scheduleChosen = Boolean(startWeek && endWeek);

  return (
    <>
      <Dialog open={open} maxWidth="md" fullWidth disableEscapeKeyDown>
        <DialogTitle>
          <Box sx={{ textAlign: "center", pt: 2 }}>
            <Typography variant="h4" gutterBottom>
              Data Use & Privacy
            </Typography>
            <Typography
              variant="subtitle1"
              color="text.secondary"
              sx={{ fontStyle: "italic" }}
            >
              Review and confirm your preferences
            </Typography>
          </Box>
        </DialogTitle>

        <DialogContent dividers>
          {/* Notification Settings */}
          <Box sx={{ mb: 4 }}>
            <Typography variant="h6" gutterBottom>
              Notification Settings
            </Typography>

            <FormControlLabel
              control={
                <Checkbox
                  checked={checked}
                  onChange={handleChange}
                  color="primary"
                />
              }
              label="Send me a weekly reminder to check the dashboard"
            />

            <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
              Notifications will be sent to your institutional email address.
              You can update these preferences anytime in your dashboard settings.
            </Typography>
          </Box>

          <Divider sx={{ my: 3 }} />

          {/* Survey Schedule */}
          <Box sx={{ mb: 4 }}>
            <Typography variant="h6" gutterBottom>
              Survey Schedule
            </Typography>

            <Button variant="outlined" onClick={openScheduleModal}>
              {scheduleChosen ? "Change Survey Schedule" : "Select Survey Weeks"}
            </Button>

            {scheduleChosen && (
              <Typography variant="body2" sx={{ mt: 1.5 }}>
                {startWeek === ALL_WEEK_STARTS[0] ? (
                  <>
                    Your first survey unlocks the week of <strong>{formatWeek(startWeek)}</strong>,
                    the second one week later, then every two weeks after that, with no surveys
                    unlocking after the week of <strong>{formatWeek(endWeek)}</strong>.
                  </>
                ) : (
                  <>
                    Surveys will unlock every two weeks, starting the week of{" "}
                    <strong>{formatWeek(startWeek)}</strong>, with no surveys unlocking after
                    the week of <strong>{formatWeek(endWeek)}</strong>.
                  </>
                )}
              </Typography>
            )}
          </Box>

          <Divider sx={{ my: 3 }} />

          {/* Data Use & Privacy */}
          <Box>
            <Typography variant="h6" gutterBottom>
              By accepting this agreement, you acknowledge that:
            </Typography>

            <Box
              component="ul"
              sx={{
                pl: 3,
                "& li": { mb: 1 },
              }}
            >
              <li>
                Downstream will collect student survey responses and Canvas
                activity data (e.g., participation, engagement patterns).
              </li>
              <li>
                Downstream reflection surveys are created as <strong>0-point</strong> Canvas
                quizzes by default, but you're free to change the point value to fit your
                grading approach.
              </li>
              <li>
                You'll choose a start week and a cutoff week for surveys above — surveys unlock
                every two weeks and data collection begins once your schedule is confirmed.
              </li>
              <li>
                Data will be used to generate course-level and student-level
                insights and support early identification of students who may need
                assistance.
              </li>
              <li>
                Data may also be used to improve the functionality and
                effectiveness of the system.
              </li>
              <li>
                All data are handled in accordance with institutional policies and
                applicable regulations (e.g., FERPA).
              </li>
              <li>
                Access to data is <strong>role-based and restricted</strong> to authorized users
                (e.g., instructors, approved personnel).
              </li>
            </Box>
          </Box>
        </DialogContent>

        <DialogActions sx={{ p: 3, justifyContent: "space-between" }}>
          <Button onClick={onBack} color="inherit">
            Back
          </Button>

          <Button
            variant="contained"
            onClick={onAccept}
            disabled={saving || !scheduleChosen}
            sx={{
              minWidth: 200,
              background: "linear-gradient(135deg, #2FA4C7, #5DBB3A)",
              color: "#fff",
              "&:hover": {
                background: "linear-gradient(135deg, #1F8FA3, #4FA52F)",
              },
            }}
          >
            {saving ? "Saving..." : "Agree & Continue"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Survey schedule picker */}
      <Dialog open={scheduleOpen} onClose={() => setScheduleOpen(false)} maxWidth="md" fullWidth>
        <DialogTitle>Choose Your Survey Schedule</DialogTitle>
        <DialogContent dividers>
          <Typography variant="body2" sx={{ mb: 2 }}>
            Pick a start week and a cutoff week below, and we'll space your surveys every two weeks — each one opens Monday and closes the following Sunday night. These dates can be edited directly in Canvas after deployment if needed.
          </Typography>

          {loadingWeeks ? (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="120px">
              <CircularProgress />
            </Box>
          ) : (
            <SurveyScheduleCalendar
              allWeeks={ALL_WEEK_STARTS}
              availableWeeks={stage === "start" ? startOptions : endOptions}
              startWeek={draftStartWeek}
              endWeek={draftEndWeek}
              stage={stage}
              onSelectWeek={handleCalendarClick}
            />
          )}
        </DialogContent>
        <DialogActions sx={{ justifyContent: "space-between" }}>
          <Button onClick={handleRestartSelection} disabled={!draftStartWeek} color="inherit">
            Start Over
          </Button>
          <Box sx={{ display: "flex", gap: 1 }}>
            <Button onClick={() => setScheduleOpen(false)}>Cancel</Button>
            <Button
              onClick={handleScheduleConfirm}
              disabled={!draftStartWeek || !draftEndWeek}
              variant="contained"
            >
              Confirm
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    </>
  );
}